<template>
  <v-dialog v-model="dialog" width="100%" v-resize="onResize">
    <v-card>
      <v-card-title class="pa-1 ma-0">
        <v-btn icon @click="onCancel" class="mr-2">
          <v-icon>mdi-open-in-new</v-icon>
        </v-btn>
        <v-btn icon @click="onCancel" class="mr-2">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-btn icon @click="onCancel" class="mr-2">
          <v-icon>mdi-arrow-right</v-icon>
        </v-btn>
        <v-spacer />
        <v-btn icon @click="onCancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-1 ma-0">
        <div class="objectWrapper" :style="objectWrapperStyle">
          <iframe :src="url"></iframe>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      resolve: undefined,
      iframeHeight: 0,
      url: ''
    }
  },
  computed: {
    objectWrapperStyle() {
      return {
        height: `${this.iframeHeight}px`
      }
    }
  },
  methods: {
    open(url) {
      this.dialog = true
      this.url = url
      return new Promise(resolve => (this.resolve = resolve))
    },
    close() {
      this.dialog = false
      this.resolve(false)
    },
    onCancel() {
      this.close()
    },
    onResize() {
      this.iframeHeight = window.innerHeight * 0.75
    }
  }
}
</script>

<style scoped>
/* https://idotdesign.net/blog/web/htmlcss/iframe-responsive/ */
.objectWrapper {
  position: relative;
  height: 0px;
  /* background-color: black; */
}
.objectWrapper object {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
  object-fit: contain;
}
.objectWrapper img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
  object-fit: contain;
}

iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
